/* eslint-disable dot-notation */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IUser } from '@ddot/AddToCartCommon/lib/entities';

import { AsyncThunkAPI } from 'Redux/types';
import NavActions from 'Services/Navigation/Actions';
import Actions from 'Redux/Actions';
import Utils from 'Lib/Utils';
import { string } from 'prop-types';
import userSlice from 'Redux/slices/user';
import Atc from '../../../../Lib/ATC';

import { ErrorTypes } from '.';

interface GetUserInfoParams {
    email: string;
}
// interface GetUserInfoResponse {
//     [k: string]: number;
// }

interface GetUserInfoResponse {
    // eslint-disable-next-line camelcase
    available_points: number;
}

export default createAsyncThunk<
    GetUserInfoResponse,
    string,
    AsyncThunkAPI
>('user/getMemberPoints', async (params, thunkAPI) => {
    const response = await thunkAPI.extra.useCases.user.getMemberPoints.execute({ email: params });

    if (response.status === Atc.UseCases.Types.UseCaseResponseStatus.Success) {
        thunkAPI.dispatch(userSlice.actions.setMemberPoints(response.data.available_points || 0));
        return response.data;
    }
    if (response.data.type === ErrorTypes.GetMemberPointsError.UserNotFound) {
        return thunkAPI.rejectWithValue(response.data.title || 'User not found!');
    }

    return thunkAPI.rejectWithValue('Something went wrong. Please try again.');
});
